<template>
  <el-form
    ref="form"
    :model="model"
    :rules="rules"
    :disabled="disabled"
    :validate-on-rule-change="validateOnRuleChange"
    @submit.prevent.native="submitNative ? save : null"
  >
    <slot :error="error"></slot>
  </el-form>
</template>
<script>
import RestApi from '@/core/services/RestApi'
export default {
  name: 'RestForm',
  inject: ['restPage'],
  provide() {
    return {
      restForm: this
    }
  },
  props: {
    model: {
      required: true
    },
    rules: {
      required: false,
      type: Object
    },
    validateOnRuleChange: {
      required: false,
      type: Boolean,
      default: false
    },
    saveEndpoint: {
      required: true,
      type: Object
    },
    afterSave: {
      type: Function,
      required: false
    },
    successMessage: {
      type: String,
      required: false
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean
    },
    submitNative: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      errors: []
    }
  },
  methods: {
    error(field) {
      return this.errors.find(item => item.field === field)
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate((isValid, obj) => {
          if (isValid) {
            resolve(isValid)
            return
          }
          const err = Object.values(obj)
          reject(err)
        })
      })
    },
    validateField(field) {
      this.$refs['form'].validateField(field)
    },
    save() {
      return new Promise(resolve => {
        this.errors = []
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.startLoading()
            RestApi({ ...this.saveEndpoint, ...{ data: this.model } })
              .then(({ data }) => {
                this.$message({
                  message: this.successMessage
                    ? this.successMessage
                    : this.$t('RestForm_SaveSuccessMessage'),
                  type: 'success'
                })
                if (this.afterSave) {
                  this.afterSave(data, this.finishLoading)
                } else {
                  this.finishLoading()
                }
                resolve(data)
              })
              .catch(error => {
                if (
                  error.response &&
                  error.response.data &&
                  error.response.data.errors
                ) {
                  this.errors = error.response.data.errors
                }
                this.finishLoading()
                this.$message({
                  message: error.message,
                  type: 'error'
                })
                this.$emit('on-error', error)
              })
          }
        })
      })
    },
    startLoading() {
      if (this.restPage) {
        this.restPage.loading = true
      }
    },
    finishLoading() {
      document.getElementById('content-container').scrollTo(0, 0)
      if (this.restPage) {
        this.restPage.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestForm.vue